import { NgIf } from '@angular/common';
import { Component, output } from '@angular/core';

@Component({
  selector: 'app-terms-sheet',
  imports: [NgIf],
  standalone: true,
  templateUrl: './terms-sheet.component.html',
  styleUrl: './terms-sheet.component.scss'
})
export class TermsSheetComponent {
  onStatusChange = output<boolean>();

  visible = false;
  isReady = false;
  startY = 0;
  currentY = 0;
  offset = 100;
  dragging = false;

  ngAfterViewInit() {
    setTimeout(() => {
      this.isReady = true;
    })
  }

  open() {
    this.visible = true;

    setTimeout(() => {
      this.offset = 0;
    });
  }

  close() {
    this.offset = window.innerHeight;

    setTimeout(() => {
      this.visible = false;
    }, 300)
  }

  startDrag(event: MouseEvent | TouchEvent) {
    this.dragging = true;
    this.startY = this.getY(event);
  }

  onDrag(event: MouseEvent | TouchEvent) {
    if (!this.dragging) return;

    this.currentY = this.getY(event);
    const delta = this.currentY - this.startY;

    if (delta > 0) {
      this.offset = delta;
    }
  }

  endDrag() {
    if (!this.dragging) return;

    this.dragging = false;

    if (this.offset > 100) {
      this.close();
    } else {
      this.offset = 0;
    }
  }

  handleClose() {
    this.onStatusChange.emit(false);
    this.close();
  }

  confirm() {
    this.onStatusChange.emit(true);
    this.close();
  }

  private getY(event: MouseEvent | TouchEvent): number {
    return event instanceof MouseEvent
      ? event.clientY
      : event.touches[0].clientY;
  }

}
